export * from './AnimatedColorBox.ui';
